import { ReactElement } from 'react';
import Sparkles from '../../components/svg/Sparkles';
import MagnifyingGlass from '../../components/svg/MagnifyingGlass';
import './NoBillResults.scss';

type NoBillResultsProps = {
  noBillsMessage?: string;
  showAIStartingPoint?: boolean;
  isAISearch?: boolean;
  onStartingPointClick?: (phrase: string) => void;
};

const AI_STARTING_POINTS = ['Healthcare access', 'Clean energy', 'Data privacy'];

const NoBillResults = (props: NoBillResultsProps): ReactElement => {
  const { noBillsMessage, showAIStartingPoint, isAISearch, onStartingPointClick } =
    props;

  if (showAIStartingPoint) {
    return (
      <div className="no-bills-found no-bills-found--ai-starting-point">
        <div className="no-bills-found__sparkle-cluster">
          <Sparkles fill="#00A99D" height="48" stroke="#00A99D" width="48" />
        </div>
        <h3 className="no-bills-found__heading">Explore legislation with AI</h3>
        <p className="no-bills-found__subtext">
          Go beyond keywords - AI understands your intent, reads thousands of bills and
          returns the most relevant matches.
        </p>
        <div className="no-bills-found__starting-point-label">Try a starting point</div>
        <div className="no-bills-found__starting-points">
          {AI_STARTING_POINTS.map((phrase) => (
            <button
              className="no-bills-found__starting-point-pill"
              key={phrase}
              onClick={() => onStartingPointClick?.(phrase)}
              type="button"
            >
              {phrase}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="no-bills-found">
      <div className="no-bills-found__icon">
        <MagnifyingGlass fill="#BDBDBD" height="32" width="31" />
      </div>
      <div className="no-bills-found__heading">
        {noBillsMessage || 'No eligible bills found'}
      </div>
      <p className="no-bills-found__subtext my-2">
        Try broadening your search or checking our{' '}
        <a
          href="https://help.pluralpolicy.com/how-to-do-boolean-searches-in-plural"
          rel="noopener noreferrer"
          target="_blank"
        >
          Pro Tips
        </a>{' '}
        for keyword searching.
      </p>
      {isAISearch && (
        <>
          <div className="no-bills-found__starting-point-label">
            Try a starting point
          </div>
          <div className="no-bills-found__starting-points">
            {AI_STARTING_POINTS.map((phrase) => (
              <button
                className="no-bills-found__starting-point-pill"
                key={phrase}
                onClick={() => onStartingPointClick?.(phrase)}
                type="button"
              >
                {phrase}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default NoBillResults;
